import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import SimpleImageSlider from "react-simple-image-slider";
import {
    Box, Button, Checkbox, colors, FormControl, FormControlLabel, IconButton,
    InputLabel, LinearProgress, MenuItem, OutlinedInput, Select, TextField, Typography, Chip, Dialog
} from '@mui/material'
import {
    ManageSearchSharp, PhotoCamera, ClearSharp,
    HourglassTopRounded, AddBoxSharp,
    FlagCircleRounded,
    AssistantPhoto
} from '@mui/icons-material'
import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import axios from 'axios';

import ManageCategoriesComp from './ManageCategoriesComp';
import FinancialTableComp from './FinancialTableComp';
import BulletsSection from './BulletsSection';
import RelatedArticleSection from './RelatedArticleSection';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useStore } from '../store/StoredData';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import format from 'date-fns/format';
import ReactDatePicker from 'react-datepicker';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 3;
const menuprops = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const priorityList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const weightList = [1, 2, 3, 4, 5]

const Article = (props) => {

    const { articleContent, currentUser, setMasterIndicatorSubTree, masterCategoriesSubCategoriesTree, initDateRange, selectDateRange } = useStore();
    const MACHINE_AUTHOR_ID = '99999999999999';
    const isPendingAutodraft = String(articleContent?.author_id) === MACHINE_AUTHOR_ID;
    const history = useHistory();
    const params = useParams();

    const [author, setAuthor] = useState("");
    const [loggedInEditorName, setLoggedInEditorName] = useState("");
    const [articleVersion, setArticleVersion] = useState(null);
    const [datePublished, setDatePublished] = useState();
    const [lastUpdated, setLastUpdated] = useState();
    const [articleTitle, setArticleTitle] = useState("")
    const [articleSummary, setArticleSummary] = useState("")
    const [articleDescriptionState, setArticleDescriptionState] = useState("");
    const [convertedContentArticleDescription, setConvertedContentArticleDescription] = useState("");
    const [articlePhoto, setArticlePhoto] = useState("")
    const [articlePictureFile, setArticlePictureFile] = useState("")
    const [articleImageURL, setArticleImageURL] = useState("")
    const [imageAltTag, setImageAltTag] = useState("")
    const [imageCaption, setImageCaption] = useState("")
    const [imageList, setImageList] = useState([]);

    const [location, setLocation] = useState("")
    const [locationList, setLocationList] = useState([])
    const [locationSuggestion, setLocationSuggestions] = useState([]);
    const [locationSuggDropDownState, setLocationSuggDropDownState] = useState(false);
    const [locationSuggLoading, setLocationSuggLoading] = useState(false);

    const [peopleNames, setPeopleNames] = useState("")
    const [peopleNamesList, setPeopleNamesList] = useState([])
    const [peopleSuggestion, setPeopleSuggestions] = useState([]);
    const [peopleSuggDropDownState, setPeopleSuggDropDownState] = useState(false);
    const [peopleSuggLoading, setPeopleSuggLoading] = useState(false);

    const [industry, setIndustry] = useState("")
    const [industryList, setIndustryList] = useState([])
    const [industrySuggestion, setIndustrySuggestions] = useState([]);
    const [industrySuggDropDownState, setIndustrySuggDropDownState] = useState(false);
    const [industrySuggLoading, setIndustrySuggLoading] = useState(false);

    const [company, setCompany] = useState("")
    const [companyList, setCompanyList] = useState([])
    const [companySuggestion, setCompanySuggestions] = useState([]);
    const [companySuggDropDownState, setCompanySuggDropDownState] = useState(false);
    const [companySuggLoading, setCompanySuggLoading] = useState(false);

    const [tickersList, setTickersList] = useState([]);

    const [assignedMasterMacroIndicatorTree, setAssignedMasterMacroIndicatorTree] = useState([]);
    const [selectedMacroIndicator, setSelectedMacroIndicator] = useState();
    const [selectedMacroIndicatorList, setSelectedMacroIndicatorList] = useState([])
    const [selectedMacroSubIndicatorList, setSelectedMacroSubIndicatorList] = useState([])

    const [assignedMasterCategoriesSubCategoriesTree, setAssignedMasterCategoriesSubCategoriesTree] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedCategoryList, setSelectedCategoryList] = useState([])
    const [selectedSubCatList, setSelectedSubCatList] = useState([])
    const [openCategoryModal, setOpenCategoryModal] = useState(false)

    const [selectedPriority, setSelectedPriority] = useState(articleContent.news_priority);
    const [selectedWeight, setSelectedWeight] = useState(3);
    const [isFeatured, setIsFeatured] = useState(false)
    const [isArticleIndexable, setIsArticleIndexable] = useState(false)
    const [imageType, setImageType] = useState("")
    const [imageCredit, setImageCredit] = useState("")
    const [isModified, setIsModified] = useState(false)

    const [articleDescription, setArticleDescription] = useState("");
    const quillRef = useRef();


    const [dateRange, setDateRange] = useState(initDateRange);
    const [searchKeywords, setSearchKeywords] = useState([])
    const [searchCompany, setSearchCompany] = useState([])
    const [searchByCategoryId, setSearchByCategoryId] = useState([])
    const [searchBySubCategoryId, setSearchBySubCategoryId] = useState([])
    const [authorList, setAuthorList] = useState([])
    const [searchByAuthor, setSearchByAuthor] = useState([])
    const [searchArticleLoading, setSearchArticleLoading] = useState(false)

    const [searchResultArticles, setSearchResultArticles] = useState([])
    const [editorsSelectedArticles, setEditorsSelectedArticles] = useState([])
    const [editorsSelectedArticlesId, setEditorsSelectedArticlesId] = useState(articleContent.related_article_ids)
    // const [editorsSelectedArticlesId, setEditorsSelectedArticlesId] = useState([])

    // console.log("editorsSelectedArticlesId", editorsSelectedArticlesId, articleContent.related_article_ids)



    const FetchRelatedArticles = async (ids) => {
        try {
            // Create an array of request promises
            const requests = ids?.map(id => axios.get(`/api/articles/${id}`));

            // Execute all requests at once
            const responses = await Promise.all(requests);

            // Extract the data from each response and store in state
            const data = responses.map(res => {
                const { id, title, title_slug, gmt_logtime } = res?.data?.message[0]
                return { article_id: id, title, title_slug, gmt_logtime }
            });
            setEditorsSelectedArticles(data);

            // setEditorsSelectedArticles(data);

            console.log("Fetched Articles:", data);
        } catch (error) {

            console.error("Error fetching articles:", error);
        }
    }

    useEffect(() => {
        FetchRelatedArticles(articleContent.related_article_ids)
    }, [articleContent?.related_article_ids])


    // const validateInternalLink = (url) => {
    //     if (typeof url !== "string") return false;

    //     // Must start with /company, /people, or /news
    //     if (!url.startsWith("/company/") && !url.startsWith("/people/") && !url.startsWith("/news/")) {
    //         return false;
    //     }

    //     // Use case-insensitive patterns for slugs
    //     const companyPattern = /^\/company\/[A-Z]+$/;
    //     const peoplePattern = /^\/people\/\d{4,}-[a-z-]+$/;
    //     const newsPattern = /^\/news\/\d{8,}\/[\w-]+$/i;

    //     if (companyPattern.test(url) || peoplePattern.test(url) || newsPattern.test(url)) {
    //         return url;
    //     }

    //     return false;
    // };


    const COMPANY_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "company" must be in lower case Followed by "/" \n
The ticker must be always in UPPERCASE. example "AAPL" not "aapl" or "Aapl" etc. \n
Final Internal Link format must be like this - "/company/<TICKER>". example: "/company/AAPL"
`;

    const PEOPLE_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "people" must be in lower case Followed by "/" \n
The person slug must always start with person_id, then person name as slug, separated by "-". example "123456-bill-gates" \n
Final Internal Link format must be like this - "/people/<person_id-person_slug>". example: "/people/123456-bill-gates"
`;

    const ARTICLE_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "news" must be in lower case Followed by "/" \n
The article_id must always be a Number,then followed by "/" \n
Then followed by article_slug. example "2025123123595/apple-releases-new-iphone-15" \n
The article slug part must not contain any special characters such as - "% , | . ? ' " #" \n
Final Internal Link format must be like this - "/news/<article_id/article_slug>". example: "/news/20251231235959999/apple-releases-new-iphone-15"
`;

    const HTTPS_URL_RULES = `
Always start with "https://" \n
Domain must contain letters/numbers/hyphens separated by dots \n
Must end with top-level domain of 2+ letters (.com, .org, etc.) \n
Subdomains are allowed (www, blog, etc.) \n
Optional path can contain any non-whitespace characters \n
No spaces allowed anywhere in the URL \n
Examples: "https://example.com", "https://sub.domain.org/path?query=value"
`;
    // const validateInternalLink = (url) => {
    //     if (typeof url !== "string") return false;

    //     // Use a unified pattern to check the start, as the specific patterns below handle the full path
    //     const startsWithValidPrefix = url.startsWith("https://") || url.startsWith("/company/") || url.startsWith("/people/") || url.startsWith("/news/");

    //     // 1. Initial Prefix Check (Handles URLs like "/notvalid")
    //     if (!startsWithValidPrefix) {
    //         // Return false for a completely unknown path
    //         return false;
    //     }

    //     // 2. Define Patterns (Ensure /people/ and /news/ are case-insensitive)
    //     const companyPattern = /^\/company\/[A-Z]+$/;
    //     const peoplePattern = /^\/people\/\d{4,}-[a-z-]+$/;
    //     const newsPattern = /^\/news\/\d{8,}\/[\w-]+$/;

    //     if (url.startsWith("https://")) {
    //         return url;
    //     }

    //     // 3. Specific Validation Checks
    //     if (url.startsWith("/company/")) {
    //         return companyPattern.test(url) ? url : 'invalid_company';
    //     }

    //     if (url.startsWith("/people/")) {
    //         return peoplePattern.test(url) ? url : 'invalid_people';
    //     }

    //     if (url.startsWith("/news/")) {
    //         return newsPattern.test(url) ? url : 'invalid_news';
    //     }

    //     // Should be unreachable if startsWithValidPrefix is true, but included for completeness.
    //     return false;
    // };

    const validateInternalLink = (url) => {
        if (typeof url !== "string" || !url.trim()) return false;

        const trimmedUrl = url.trim();

        // Define Patterns
        const httpsPattern = /^https:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/\S*)?$/;
        const companyPattern = /^\/company\/[A-Z]+$/;
        const peoplePattern = /^\/people\/\d{4,}-[a-z-]+$/;
        const newsPattern = /^\/news\/\d{8,}\/[\w-]+$/;

        // HTTPS URLs
        if (trimmedUrl.startsWith("https://")) {
            return httpsPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_https';
        }

        // Internal routes
        if (trimmedUrl.startsWith("/company/")) {
            return companyPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_company';
        }

        if (trimmedUrl.startsWith("/people/")) {
            return peoplePattern.test(trimmedUrl) ? trimmedUrl : 'invalid_people';
        }

        if (trimmedUrl.startsWith("/news/")) {
            return newsPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_news';
        }

        return false;
    };


    useEffect(() => {
        if (quillRef.current) {
            const quill = quillRef.current.getEditor();
            // Theme is 'snow' by default, and tooltip is part of the theme
            const tooltip = quill.theme.tooltip;

            // Save the original save method
            const originalSave = tooltip.save;

            // Override the save method to add validation
            tooltip.save = function () {
                const linkUrl = this.textbox.value;

                // Validate the link
                const validationResult = validateInternalLink(linkUrl);

                // Check if validation was successful (returns the URL string)
                if (typeof validationResult === 'string' && !validationResult.startsWith('invalid_')) {
                    // Apply the validated link
                    this.textbox.value = validationResult;
                    return originalSave.call(this);
                }

                // Handle specific validation errors
                let errorMessage = "Invalid link format.";

                if (validationResult === 'invalid_https') {
                    errorMessage = "❌ Invalid link format. Must start with https://. \n" + HTTPS_URL_RULES;
                } else if (validationResult === 'invalid_company') {
                    errorMessage = "❌ Invalid Company link format. Tickers must be uppercase (e.g., /company/AAPL).\n" + COMPANY_PAGE_RULES;
                } else if (validationResult === 'invalid_people') {
                    errorMessage = "❌ Invalid People link format. Must be like /people/ID-slug (e.g., /people/1234-john-doe). \n" + PEOPLE_PAGE_RULES;
                } else if (validationResult === 'invalid_news') {
                    errorMessage = "❌ Invalid News link format. Must be like /news/YYYYMMDD.../slug (e.g., /news/2025010100001/apple-launches-iphone). \n" + ARTICLE_PAGE_RULES;
                } else {
                    // For false (unknown prefix or completely invalid)
                    errorMessage = "❌ Link must be a valid internal path, starting with https://, /company/, /people/, or /news/."
                }

                alert(errorMessage);
                return false; // Prevent saving
            };

            // Cleanup on component unmount
            return () => {
                if (tooltip && originalSave) {
                    tooltip.save = originalSave;
                }
            };
        }
    }, []);


    // 🧰 Quill toolbar configuration
    const modules = {
        toolbar: {
            container: [
                [{ header: [1, 2, 3, 4, 5, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ script: "sub" }, { script: "super" }],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                [{ align: [] }],
                ["link"],
            ],
        },
        clipboard: { matchVisual: false },
    };

    // 🖋️ Quill formats (needed to allow these features)
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
        "color",
        "background",
        "align",
        "script",
    ];

    const handleChange = (content, delta, source, editor) => {
        setArticleDescription(content);
        console.log("content :::", content)
    };

    const handleAssignCategories = () => {
        let fCats = assignedMasterCategoriesSubCategoriesTree
            .filter(cat => cat.isChecked === true)
            .map(cat => ({ ...cat, subcats: cat.subcats.filter(subcat => subcat.isChecked && subcat.isChecked === true) }))
        console.log('FINAL FILTERED ASSIGNED CATS & SUB-CATS :::::: ', assignedMasterCategoriesSubCategoriesTree, fCats, selectedCategory);
        setSelectedCategoryList(fCats);
    }

    const handleCatChange = async (val) => {
        console.log('Recieved CAT to Update === ', val)
        let mVal = assignedMasterCategoriesSubCategoriesTree.map(cat => cat.cat_name === selectedCategory.cat_name)
        setAssignedMasterCategoriesSubCategoriesTree(mVal)
        const nVal = assignedMasterCategoriesSubCategoriesTree.filter(x => x.cat_name === val)
        setSelectedCategory(nVal[0])
    }

    const handleSubCatChange = async (e, subCatObj, selectedcategory) => {
        console.log('Selected CAT', selectedcategory, 'SUB-CAT Value ::: ', subCatObj, 'EVENT ::: ', e.target.checked);
        let mVal = assignedMasterCategoriesSubCategoriesTree.map(cat => {
            if (cat.cat_id === selectedCategory.cat_id) {
                let fsc = cat?.subcats?.map(subcat => {
                    if (subcat.sub_cat_id === subCatObj.sub_cat_id) {
                        return { ...subcat, isChecked: !subcat.isChecked };
                    }
                    return subcat;
                }) || [];
                setSelectedSubCatList(fsc.filter(f => f.isChecked));
                let someSelectedSubCats = fsc.some(obj => obj.isChecked);
                someSelectedSubCats ? cat.isChecked = true : cat.isChecked = false;
                return { ...cat, subcats: fsc };
            }
            return cat;
        });
        setAssignedMasterCategoriesSubCategoriesTree(mVal);
        setSelectedCategory(mVal.filter(cat => cat.cat_id === selectedcategory.cat_id)[0]);
    };

    useEffect(() => {
        const fetchEditorProfile = async () => {
            try {
                console.log("Inside the method to fetch the editor details")
                const response = await axios.get('/api/v2/editors/resolve', {
                    params: { cms_user_id: currentUser.userid }
                });
                console.log('Search API RESP === ', response.data.message);
                if (response.data.success) {
                    const editorName = response.data.message?.editor_name || response.data.message?.editor?.editor_name;
                    if (editorName) {
                        setLoggedInEditorName(editorName)
                    }
                }
            } catch (error) {
                console.error('Error fetching API data:', error);
            }
        };
        if (isPendingAutodraft && currentUser?.userid) {
            fetchEditorProfile();
        }
    }, [isPendingAutodraft, currentUser?.userid]);

    useEffect(() => {
        let blocksFromHTMLpersonOverview = htmlToDraft(articleContent.hyperlinked_description || articleContent.description);
        let formattedTextPersonOverview = ContentState.createFromBlockArray(
            blocksFromHTMLpersonOverview.contentBlocks,
            blocksFromHTMLpersonOverview.entityMap,
        );
        setArticleDescriptionState(EditorState.createWithContent(formattedTextPersonOverview))
        setArticleDescription(articleContent.description || articleContent.hyperlinked_description);
        setConvertedContentArticleDescription(articleContent.description)
        setArticleTitle(articleContent.title)
        setArticleSummary(articleContent.summary)
        setArticlePictureFile(articleContent.image_url)
        setArticlePhoto(articleContent.image_url)
        setArticleImageURL(articleContent.image_url)
        setImageList(articleContent.associated_images ? articleContent.associated_images.map(img => JSON.parse(img)) : []);
        setSelectedPriority(articleContent.news_priority)
        setSelectedWeight(articleContent.weight)
        setIsFeatured(articleContent.is_featured)
        setIsArticleIndexable(articleContent.is_article_indexable)

        // Checking Image Type by URL
        let img_type = ''
        if (articleContent?.image_url?.includes("news_images")) {
            img_type = "article"
        } else if (articleContent?.image_url?.includes("CompanyLogos")) {
            img_type = "company"
        } else {
            img_type = ""
        }
        setImageType(img_type)



        // if (articleContent.associated_images !== null && articleContent.associated_images.length) {
        //     let imgls = [];
        //     for (const key in articleContent.associated_images) {
        //         if (Object.hasOwnProperty.call(articleContent.associated_images, key)) {
        //             if (JSON.parse(articleContent.associated_images[key]).renditions) {
        //                 const url = JSON.parse(articleContent.associated_images[key]).renditions?.preview?.href || articleContent.associated_images[key].url;
        //                 const name = JSON.parse(articleContent.associated_images[key]).renditions?.preview?.originalfilename || articleContent.associated_images[key].name;
        //                 imgls.push({ url, name })

        //             } else {
        //                 const url = JSON.parse(articleContent.associated_images[key]).url;
        //                 const name = JSON.parse(articleContent.associated_images[key]).name;
        //                 imgls.push({ url, name })
        //             }
        //         }
        //     }
        //     console.log('prepared image list ==== ', imgls);
        //     setImageList(imgls);
        //     setArticleImageURL(imgls[0]?.url)
        // } else {
        //     axios.get(`/api/article/images/${articleContent.item_id}`).then(resp => {
        //         let iList = resp.data.message.map(img => ({ name: img.item_renditions_preview.originalfilename, url: img.item_renditions_preview.href }));
        //         console.log('RECVD IMAGE INFO ==== ', iList);
        //         setImageList(iList);
        //         setArticleImageURL(iList[0]?.url);
        //     });
        // }

        setImageAltTag(articleContent.image_alt_text)
        setImageCaption(articleContent.image_caption_text)
        setImageCredit(articleContent?.image_credit)
        // Earlier implementation
        // setAuthor(articleContent.author_name);
        // Pending autodraft Author dropdown started empty
        // if (String(articleContent.author_id) === MACHINE_AUTHOR_ID) {
        //     setAuthor("");
        // } else {
        //     setAuthor(articleContent.author_name);
        // }
        // New implementation: open with the stored name (USinMinutes / INminutes / whatever is there)
        setAuthor(articleContent.author_name);
        setArticleVersion(articleContent.item_version);
        setDatePublished(articleContent.gmt_logtime);
        setLastUpdated(articleContent?.updated_time);

        if (articleContent.places && articleContent.places.length)
            setLocationList(articleContent.places)

        if (articleContent.company_name && articleContent.company_name.length)
            setCompanyList(articleContent.company_name?.filter(c => c))
        console.log('articleContent.company_name - ', companyList)
        // setAssociatedCompanies()

        if (articleContent.ticker && articleContent.ticker.length)
            setTickersList(articleContent.ticker)

        /* if (articleContent.organisations && articleContent.organisations.length) {
        let comps = articleContent.organisations.map(obj => ({ name: obj.name, ticker: obj.symbols[0].ticker, exchange: obj.symbols[0].exchange }));
        let industries = articleContent.organisations.map(obj => obj.industries.map(ind => ({ name: ind.name, code: ind.code })));
        industries = [...new Set(...industries)].flatMap(o => o);
        setCompanyList(comps)
        setIndustryList(industries)
        } */

        if (articleContent.persons && articleContent.persons.length)
            setPeopleNamesList(articleContent.persons)

        if (articleContent.macro_indicators && articleContent.macro_indicators.length)
            setSelectedMacroIndicatorList(articleContent.macro_indicators);


        if (props.isEditable) {
            const fetchMasterMacroIndicatorTree = () => {
                axios.get(`/api/master-macro-indicators-tree`)
                    .then(async (resp) => {
                        // console.log("master-macro-indicators-tree :::", resp.data.message);
                        setMasterIndicatorSubTree(resp.data.message || [])
                        let data = await resp.data.message.map(cats => {
                            let mapped = cats.indicators.map(obj => {
                                return { ...obj, isChecked: false };
                            });
                            return { ...cats, isChecked: false, indicators: mapped };
                        });

                        if (articleContent.macro_indicators)
                            for (const obj of articleContent.macro_indicators) {
                                data.map(o => {
                                    if (obj.category_id === o.category_id) {
                                        o.isChecked = true;
                                        for (const ind of obj.indicators) {
                                            o.indicators.filter(x => x.indicator_id === ind.indicator_id).map(y => {
                                                y.isChecked = true;
                                            });
                                        }
                                    }
                                });
                            };
                        console.log('INITIAL MAPPED MACRO INDICATORS DATA :::: ', data);
                        setAssignedMasterMacroIndicatorTree(data);
                    }).catch((err) => console.log("Error :::", err))
            }
            fetchMasterMacroIndicatorTree();
        }
    }, []);


    useEffect(() => {
        const assignCategoryTree = () => {
            let data = masterCategoriesSubCategoriesTree.filter((cats) => cats.cat_hide === false).map(cats => {
                let mapped = cats?.subcats?.filter((subcats) => subcats.sub_cat_hide === false)?.map(obj => {
                    return { ...obj, isChecked: false };
                }) || [];
                return { ...cats, isChecked: false, subcats: mapped };
            })

            if (articleContent.master_category_id)
                for (const catid of articleContent.master_category_id) {
                    data.map(o => {
                        if (catid == o.cat_id) {
                            o.isChecked = true;
                            if (articleContent?.sub_category_id && Array.from(articleContent?.sub_category_id).length > 0) {
                                for (const subcat of articleContent.sub_category_id) {
                                    o.subcats.filter(x => x.sub_cat_id == subcat).map(y => {
                                        y.isChecked = true;
                                    });
                                }
                            }
                        }
                    });
                };
            // console.log('MAPPED CATEGORY DATA :::: ', data);
            setAssignedMasterCategoriesSubCategoriesTree(data);
            let checkedCategories = data.filter((cat) => cat.isChecked === true
                // {
                //     let f = []
                //     if (cat.isChecked === true) {
                //         console.log("PRE Filtered SUB CATS ::", cat.subcats.filter(subcat => subcat.isChecked === true))
                //         f = cat.subcats.filter(subcat => subcat.isChecked === true)
                //         console.log('POST FILTER  ========== ', f)
                //         return { ...cat }
                //     }
                // }
            )
            // console.log("Pre-Checked Categories :::", checkedCategories)

            let filterSubcatsChecked = checkedCategories.map((cat) => {
                let f = []
                f = cat.subcats.filter((sub) => sub.isChecked === true)
                return { ...cat, subcats: f }
            })

            // console.log("Pre-Checked Sub Categories :::", filterSubcatsChecked)

            setSelectedCategoryList(filterSubcatsChecked)
        }

        if (props.isEditable) {
            assignCategoryTree();
        }

    }, [masterCategoriesSubCategoriesTree])

    // const updateArticleImageUrl = () => {
    //     if (imageList.length > 0)
    //         updateArticleImageUrl(imageList[0].url)
    //     else
    //         updateArticleImageUrl("")
    // }

    const handleImageDelete = (img) => {
        setImageList(imgs => imgs.filter(fimg => fimg.url !== img.url));
        // updateArticleImageUrl();
    }

    useEffect(() => {
        if (imageList.length > 0)
            setArticleImageURL(imageList[0].url)
        else
            setArticleImageURL("")
    }, [imageList.length])
    // console.log("Update IMAGE URL POST DELETE === ", articleImageURL)

    const handleMacroIndicatorChange = async (e, indicator, selectedcategory) => {
        // console.log('Selected CAT', selectedcategory, 'Indicator Value ::: ', indicator, 'EVENT ::: ', e.target.checked);
        let mVal = assignedMasterMacroIndicatorTree.map(cat => {
            if (cat.category_id === selectedMacroIndicator.category_id) {
                let fsc = cat.indicators.map(ind => {
                    if (ind.indicator_id === indicator.indicator_id) {
                        return { ...ind, isChecked: !ind.isChecked };
                    }
                    return ind;
                })
                setSelectedMacroSubIndicatorList(fsc.filter(f => f.isChecked));
                let someSelectedIndicators = fsc.some(obj => obj.isChecked);
                someSelectedIndicators ? cat.isChecked = true : cat.isChecked = false;
                return { ...cat, indicators: fsc };
            }
            return cat;
        });

        setAssignedMasterMacroIndicatorTree(mVal);
        setSelectedMacroIndicator(mVal.filter(cat => cat.category_id === selectedcategory.category_id)?.[0]);
    };
    // console.log('AssignedMasterMacroIndicatorTree:::', assignedMasterMacroIndicatorTree)

    const handleAssignMacroIndicator = () => {
        let fCats = assignedMasterMacroIndicatorTree
            .filter(cat => cat.isChecked === true)
            .map(cat => ({ ...cat, indicators: cat.indicators.filter(ind => ind.isChecked === true) }))
        // console.log('Final Filtered ASSIGNED MACRO INDICATORS :::::: ', fCats);
        setSelectedMacroIndicatorList(fCats);
    }

    const handleEditorArticleDescription = (state) => {
        if (state) {
            setArticleDescriptionState(state);
            convertContentToHTMLArticleDescription();
        }
    }
    const convertContentToHTMLArticleDescription = () => {
        let currentContentAsHTML = draftToHtml(convertToRaw(articleDescriptionState?.getCurrentContent()));
        setConvertedContentArticleDescription(currentContentAsHTML);
    }

    const saveArticle = async () => {

        let formData = new FormData();

        formData.append("is_article_indexable", isArticleIndexable)
        formData.append("title", articleTitle || '')
        formData.append("summary", articleSummary || '')
        // formData.append("description", convertedContentArticleDescription || '')
        formData.append("description", articleDescription || '')
        // Earlier implementation
        // formData.append("author_name", author || JSON.parse(JSON.stringify(localStorage.getItem('user'))).first_name)
        // New implementation: send author_id only when the editor selected their logged-in name, not when the stored name is left as-is
        if (isPendingAutodraft && String(author) === String(currentUser.userid)) {
            formData.append("author_id", currentUser.userid)
            // Earlier implementation
            // formData.append("author_name", currentUser.first_name)
            formData.append("author_name", loggedInEditorName || currentUser.first_name)
        } else if (isPendingAutodraft) {
            formData.append("author_name", author || articleContent.author_name || '')
        } else {
            formData.append("author_name", author || '')
        }
        formData.append("image_alt_text", imageAltTag || '')
        formData.append("image_caption_text", imageCaption || '')
        formData.append("news_priority", selectedPriority || '')
        formData.append("is_featured", isFeatured)
        formData.append("gmt_logtime", articleContent.gmt_logtime)
        formData.append("image_type", imageType)
        formData.append("image_credit", imageCredit || '')
        // selectedCategoryList.length > 0
        //     ? selectedCategoryList.forEach(cat => formData.append("assigned_cats_subcats", JSON.stringify({ cat_id: cat.cat_id, cat_name: cat.cat_name, subcats: cat.subcats?.map(sc => ({ sub_cat_id: sc.sub_cat_id, sub_cat_name: sc.sub_cat_name })) })))
        //     : formData.append("assigned_cats_subcats", '');

        // assignedMasterCategoriesSubCategoriesTree.forEach(cat => formData.append("assigned_cats_subcats", JSON.stringify({ cat_id: cat.cat_id, cat_name: cat.cat_name, subcats: cat.subcats?.map(sc => ({ sub_cat_id: sc.sub_cat_id, sub_cat_name: sc.sub_cat_name })) })))
        let fCats = assignedMasterCategoriesSubCategoriesTree.filter(x => x.isChecked)
        let fAssignedCats = [], MasterCatIds = [], MasterSubCatIds = [];
        for await (const cat of fCats) {
            console.log('F CAT = ', cat)
            MasterCatIds.push(cat.cat_id)
            let fsc = cat.subcats.filter(x => x.isChecked)
            fsc.map(x => MasterSubCatIds.push(x.sub_cat_id))
            console.log('F SUB-CAT = ', fsc)
            fAssignedCats.push({ ...cat, subcats: fsc })
        }
        console.log('F fAssignedCats = ', fAssignedCats, MasterCatIds, MasterSubCatIds)
        fAssignedCats.forEach(a => formData.append("assigned_cats_subcats", JSON.stringify(a)))
        MasterCatIds.forEach(x => formData.append("master_category_ids", x))
        MasterSubCatIds.forEach(x => formData.append("master_subcategory_ids", x))

        locationList.length ? locationList.map(o => formData.append("places", JSON.stringify(o))) : formData.append("places", '');
        peopleNamesList.length ? peopleNamesList.map(o => formData.append("people", JSON.stringify(o))) : formData.append("people", '');
        industryList.length ? industryList.map(o => formData.append("industry", JSON.stringify(o))) : formData.append("industry", '');
        companyList.length ? companyList.map(o => formData.append("company", o)) : formData.append("company", '');
        // associatedCompanies.length ? associatedCompanies.map(o => formData.append("company", o)) : formData.append("company", '');
        tickersList.length ? tickersList.map(o => formData.append("tickers", o)) : formData.append("tickers", '');
        selectedMacroIndicatorList.length ? selectedMacroIndicatorList.map(o => formData.append("macro_indicators", JSON.stringify(o))) : formData.append("macro_indicators", '');
        if(editorsSelectedArticlesId !== null){
        editorsSelectedArticlesId.length ? editorsSelectedArticlesId.map(o => formData.append("editor_related_articles", o)) : formData.append("editor_related_articles", '');
        }
        let correctImageURL = articleImageURL.startsWith('blob:') ? "" : articleImageURL
        !!articleImageURL ? formData.append("image_url", correctImageURL) : formData.append("image_url", "");
        imageList.length ? imageList.map(img => formData.append("article_photo", img.file || JSON.stringify(img))) : formData.append("article_photo", '');

        console.log("Article Image URL before sending :::", articleImageURL)
        console.log("imageList before sending :::", imageList)
        console.log("selectedCategoryList before sending :::", selectedCategoryList)

        for (const val of formData) console.log('Final Subit API DAta::: ', val[0], val[1])

        await axios({
            method: 'PUT',
            url: `/api/v2/article/${params.id}`,
            headers: { 'Content-Type': 'multipart/form-data; boundary="boundary"' },
            data: formData
        }).then(resp => {
            console.log('Saved Article Successfully... ', resp.data.message);
            alert('Article Updated Successfully!');
            window.location.reload()
        }).catch(error => console.error(`Error While Saving Article, ${error}`));
    }

    const uploadProfilePicture = async (e) => {
        e.preventDefault();
        // setArticlePhoto(e.target.files[0])
        setArticlePictureFile(URL.createObjectURL(e.target.files[0]))
        for (let i = 0; i < e.target.files.length; i++) {
            // console.log('uploaded photo info ::: ', e.target.files, URL.createObjectURL(e.target.files[i]), "Name ::", e.target.files[i].name, "file", e.target.files[i]);
            imageList.push({ url: URL.createObjectURL(e.target.files[i]), name: e.target.files[i].name, file: e.target.files[i] })
        }
        // articlePhoto.push(e.target.files[i])
    };

    // console.log("Image List ::: ", imageList, "\t|\tIMAGE_URL ::: ", articleImageURL);

    const handleLocationList = (selectedLocation) => {
        // console.log("selected Location :::", selectedLocation);
        setLocationList(prev => [...prev, selectedLocation])
    }

    const handleDeleteLocation = (loc) => {
        // console.log("Deleting Location :::", loc)
        setLocationList(locationList.filter(location => location.name !== loc.name))
    }
    const handlePeopleNamesList = (selectedPeople) => {
        setPeopleNamesList(prev => [...prev, selectedPeople])

    }

    const handleDeletePeople = (ppl) => {
        // console.log("Deleting People :::", ppl)
        setPeopleNamesList(peopleNamesList.filter(people => people.name !== ppl.name))
    }

    const handleIndustryList = (selectedIndustry) => {
        // console.log('Selected Industry === ', selectedIndustry)
        setIndustryList(prev => [...prev, { code: selectedIndustry.sic_grp_code, name: selectedIndustry.sic_grp_name }])
    }

    const handleDeleteIndustry = (ind) => {
        // console.log("Deleting Industry :::", ind)
        setIndustryList(industryList.filter(industry => industry.code !== ind.code))
    }

    const handleCompanyList = (selectedCompany) => {
        // console.log('Selected Company === ', selectedCompany)
        // setAssociatedCompanies(prev => [...prev, selectedCompany]);
        setCompanyList(prev => [...prev, selectedCompany.name]);
        // console.log('RECVD TICKER ::: ', selectedCompany.ticker);
        setTickersList(prev => [...prev, selectedCompany.ticker ? selectedCompany.ticker : ''])
    }

    const handleDeleteCompany = (comp) => {
        // console.log("Deleting Company :::", comp)
        setCompanyList(companyList.filter(company => company !== comp));
        if (tickersList.length)
            setTickersList(prev => prev.filter(o => o !== comp.ticker))
        // setAssociatedCompanies(prev => prev.filter(o => o.cik !== comp.cik))
    }

    // console.log('Company List ::: ', companyList);
    // console.log('Tickers List ::: ', tickersList);
    // console.log('Associated Companies List ::: ', associatedCompanies);

    const handlePeopleData = (inputData) => {
        if (inputData.length > 2) {
            setPeopleSuggLoading(true);
            setPeopleSuggestions([]);
            axios.get('/api/person', { params: { s: inputData } }).then((resp) => {
                setPeopleSuggDropDownState(true);
                setPeopleSuggestions(resp.data.message);
                setPeopleSuggLoading(false);
            });
        } else {
            setPeopleSuggestions([]);
            setPeopleSuggDropDownState(false);
        }
    };

    const handleIndustryTypeahead = (inputData) => {
        if (inputData.length > 2) {
            setIndustrySuggLoading(true);
            setIndustrySuggestions([]);
            axios.get('/api/industries', { params: { s: inputData } }).then((resp) => {
                setIndustrySuggDropDownState(true);
                setIndustrySuggestions(resp.data.message);
                setIndustrySuggLoading(false);
            });
        } else {
            setIndustrySuggestions([]);
            setIndustrySuggDropDownState(false);
        }
    };

    const handleCompanyTypeahead = (inputData) => {
        if (inputData.length > 2) {
            setCompanySuggLoading(true);
            setCompanySuggestions([]);
            axios.get('/api/companies', { params: { s: inputData } }).then((resp) => {
                setCompanySuggDropDownState(true);
                setCompanySuggestions(resp.data.message);
                setCompanySuggLoading(false);
            });
        } else {
            setCompanySuggestions([]);
            setCompanySuggDropDownState(false);
        }
    };

    const debounce = (func) => {
        let timer;
        return function (...args) {
            const context = this;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                func.apply(context, args);
            }, 400);
        };
    };

    const optimizedPeopleFn = useCallback(debounce(handlePeopleData), []);
    const optimizedIndustryeFn = useCallback(debounce(handleIndustryTypeahead), []);
    const optimizedCompanyFn = useCallback(debounce(handleCompanyTypeahead), []);

    // console.log("Final Selected Location :::", locationList)
    // console.log("Final Selected People :::", peopleNamesList)
    // console.log("Final Selected Industry :::", industryList)
    // console.log("Final Selected Companies :::", companyList)
    // console.log("Final Selected Tickers :::", tickersList)
    // console.log("Final Selected MacroIndicator :::", selectedMacroIndicatorList)

    const handleSaveImage = async () => {

        if (!imageAltTag) {
            alert('Please Enter Image Alt Tag');
            return
        }

        if (!imageCaption) {
            alert('Please Enter Image Caption');
            return
        }

        if (!imageType) {
            alert('Please Select Store Image Type');
            return
        }

        if (!articleImageURL) {
            alert('Please Upload Image');
            return
        }

        let formData = new FormData();

        formData.append("image_alt_text", imageAltTag || '')
        formData.append("image_caption_text", imageCaption || '')
        formData.append("image_type", imageType)
        formData.append("image_credit", imageCredit || '')

        let correctImageURL = articleImageURL.startsWith('blob:') ? "" : articleImageURL
        !!articleImageURL ? formData.append("image_url", correctImageURL) : formData.append("image_url", "");
        imageList.length ? imageList.map(img => formData.append("article_photo", img.file || JSON.stringify(img))) : formData.append("article_photo", '');

        console.log("Article Image URL before sending :::", articleImageURL)
        console.log("imageList before sending :::", imageList)

        for (const val of formData) console.log('Final Subit API DAta::: ', val[0], val[1])

        await axios({
            method: 'PUT',
            url: `/api/upload-image/${params.id}`,
            headers: { 'Content-Type': 'multipart/form-data; boundary="boundary"' },
            data: formData
        }).then(resp => {
            console.log('Saved Article Successfully... ', resp.data.message);
            alert('Article Updated Successfully!');
            window.location.reload()
        }).catch(error => console.error(`Error While Saving Article, ${error}`));
    }






    const handleDateRange = (currDt) => {
        setDateRange(prvDt => {
            if (prvDt === currDt) {
                selectDateRange(currDt);
                return currDt
            } else {
                selectDateRange(currDt);
                return currDt
            }
        });
    }


    const handleSearchArticle = async () => {
        console.log({ searchByAuthor, searchByCategoryId, searchBySubCategoryId, searchCompany, searchKeywords, dateRange })
        if (searchByAuthor || searchByCategoryId || searchBySubCategoryId || searchCompany || searchKeywords || dateRange) {
            setSearchArticleLoading(true);
            try {
                const response = await axios.get(`/api/v3/articles/search`, {
                    params: {
                        author: searchByAuthor,
                        categoryId: searchByCategoryId,
                        subCategoryId: searchBySubCategoryId,
                        company: searchCompany,
                        keywords: searchKeywords,
                        startdate: format(dateRange[0], "yyyy-MM-dd"),
                        enddate: format(dateRange[1], "yyyy-MM-dd"),
                    }
                });
                console.log('Search API RESP === ', response.data.message);
                setSearchResultArticles(response.data.message.rows);
                setSearchArticleLoading(false);
            } catch (error) {
                console.error('Error fetching API data:', error);
                setSearchArticleLoading(false);
            }
        }
    }


    const handleArticleSelect = (articleId) => {
        if (editorsSelectedArticlesId?.length > 0) {
            setEditorsSelectedArticlesId((prevSelected) => {
            if (prevSelected.includes(articleId)) {
                // If already selected, remove it
                return prevSelected.filter((id) => id !== articleId);
            } else {
                // If not selected, add it
                return [...prevSelected, articleId];
            }
        });
        console.log("editorsSelectedArticlesId in if handleArticleSelect----", editorsSelectedArticlesId)
        }else{
            setEditorsSelectedArticlesId([]);
            setEditorsSelectedArticlesId((prevSelected) => {
            if (prevSelected.includes(articleId)) {
                // If already selected, remove it
                return prevSelected.filter((id) => id !== articleId);
            } else {
                // If not selected, add it
                return [...prevSelected, articleId];
            }
            });
        console.log("editorsSelectedArticlesId in else handleArticleSelect----", editorsSelectedArticlesId)
        }
    };
    
    const handleSelectedArticles = () => {
        console.log("editorsSelectedArticlesId in handleSelectedArticles----", editorsSelectedArticlesId)
        if (editorsSelectedArticlesId.length > 0) {
            let filterArticles = searchResultArticles.filter((article) => editorsSelectedArticlesId.includes(article.article_id));
            // console.log("Selected Articles>>>", filterArticles)
            setEditorsSelectedArticles(prev => [...prev, ...filterArticles]);
            // setSearchResultArticles([])
        }
    }

    const handleRemoveRelatedArticle = (articleId) => {
        setEditorsSelectedArticlesId((prevSelected) => prevSelected.filter((id) => id !== articleId));
        setEditorsSelectedArticles((prevSelected) => prevSelected.filter((article) => article.article_id !== articleId));
    }


    console.log("selectedArticles", editorsSelectedArticles, editorsSelectedArticlesId, searchResultArticles)

    return (
        <>
            {articleContent
                ? <>
                    {
                        articleContent === null &&
                        <Box width="100%" textAlign="center" my={5} >
                            <Typography variant='body1' color={colors.deepOrange[300]}>No Article Details Available...</Typography>
                        </ Box >
                    }
                    {
                        articleContent !== null && !props.isEditable
                            ? <div id="article" style={{ border: '2px solid #eaeaea', borderRadius: 5, width: '100%', textAlign: 'left' }}>
                                <Typography variant='h6' color={colors.deepOrange[800]}>Associated AP Topics:&ensp;</Typography>
                                <Box border={1} borderColor={colors.blue[200]} borderRadius={1} my={1} mx="auto" p={1}>
                                    <Typography variant='h6' color={colors.deepOrange[800]}>Associated AP Subjects:&ensp;</Typography>
                                    <Box display="flex" flexDirection="row" flexWrap='wrap' p={1} alignContent='center' alignItems="center">
                                        {articleContent.article_subjects && Array.from(articleContent.article_subjects).length > 0
                                            ? <>
                                                {Array.from(articleContent.article_subjects).map(subject =>
                                                    subject.name.length > 2 &&
                                                    <Chip
                                                        key={subject.code}
                                                        variant='outlined'
                                                        size='small'
                                                        sx={{ color: colors.deepPurple[500], m: 0.25 }} label={`${subject.name} [${subject.code}] ${subject.relevance ? `(${subject.relevance})` : ''}`} />)}
                                            </>
                                            : null}
                                    </Box>
                                </Box>
                                <Box border={1} borderColor={colors.blue[200]} borderRadius={1} my={1} mx="auto" p={1}>
                                    {articleContent.product_ids && Array.from(articleContent.product_ids).length > 0
                                        ? <>{Array.from(articleContent.product_ids).map(keyword => <Chip variant='outlined' size='small' sx={{ color: colors.deepPurple[500], m: 0.25 }} label={`${keyword.name} [${keyword.id}]`} />)}</>
                                        : null}
                                </Box>
                                <hr />
                                <div style={{ padding: '0px 5px', margin: '20px 0px' }}>
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800] }}>TITLE:</h5>
                                    <div>{articleContent.title}</div>
                                </div>
                                <div style={{ padding: '0px 5px', margin: '20px 0px' }}>
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800] }}>SUMMARY:</h5>
                                    <div dangerouslySetInnerHTML={{ __html: articleContent.summary }}></div>
                                </div>
                                <Box position="relative" display='flex' justifyContent='center' alignItems='center'>
                                    {/* <img width="100%" height='50%' src={articlePictureFile} /> */}
                                    {imageList.length > 0 &&
                                        <Box>
                                            <SimpleImageSlider
                                                width={825}
                                                height={425}
                                                images={imageList}
                                                showBullets={true}
                                                style={{ objectFit: 'contain' }}
                                            // showNavs={true}
                                            />
                                        </Box>
                                    }
                                </Box>
                                <div style={{ padding: '0px 5px', margin: '20px 0px' }}>
                                    {/* Bullet Points Goes here */}
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800] }}>BULLET POINTS:</h5>
                                    <BulletsSection data={articleContent?.article_bullets} />
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800] }}>DESCRITPION:</h5>
                                    <div dangerouslySetInnerHTML={{ __html: articleContent.description }}></div>

                                    {/* Financial Table Goes here */}
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800], marginTop: 20 }}>FINANCIAL TABLE:</h5>
                                    <FinancialTableComp data={articleContent?.article_table} />
                                    {/* Related Articles Goes here */}
                                    <h5 style={{ margin: 0, padding: 0, color: colors.deepOrange[800] }}>RELATED ARTICLE:</h5>
                                    <RelatedArticleSection data={articleContent?.related_news} />
                                </div>
                            </div>
                            :
                            /* ########## Edit Section ########## */
                            <Box>
                                <Box border={1} borderColor={colors.blue[200]} borderRadius={1} my={1} boxShadow={2} p={2}>
                                    <Typography variant='h6' color={colors.deepOrange[800]}>Associated AP Subjects:&ensp;</Typography>
                                    <Box display="flex" flexDirection="row" flexWrap='wrap' p={1} alignContent='center' alignItems="center">
                                        {articleContent.article_subjects && Array.from(articleContent.article_subjects).length > 0
                                            ? <>
                                                {Array.from(articleContent.article_subjects).map(subject => subject.name.length > 2 && <Chip key={subject.code} variant='outlined' size='small' sx={{ color: colors.deepPurple[500], m: 0.25 }} label={`${subject.name} [${subject.code}] ${subject.relevance ? `(${subject.relevance})` : ''}`} />)}
                                            </>
                                            : null}
                                    </Box>
                                </Box>

                                <Box border={1} borderColor={colors.blue[200]} borderRadius={1} my={1} boxShadow={2} p={2}>
                                    <Typography variant='h6' color={colors.deepOrange[800]}>Associated AP Topics:&ensp;</Typography>
                                    <Box display="flex" flexDirection="row" flexWrap='wrap' p={1} alignContent='center' alignItems="center">
                                        {articleContent.product_ids && Array.from(articleContent.product_ids).length > 0
                                            ? <>
                                                {Array.from(articleContent.product_ids).map(keyword => <Chip variant='outlined' size='small' sx={{ color: colors.deepPurple[500], m: 0.25 }} label={`${keyword.name} [${keyword.id}]`} />)}
                                            </>
                                            : null}
                                    </Box>
                                </Box>

                                <Box display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center" alignItems="center" p={2} boxShadow={1} bgcolor={colors.blueGrey[50]}>
                                    <Typography color={colors.indigo[900]}>Assigned Tabs & Subtabs:</Typography>&emsp;
                                    {assignedMasterCategoriesSubCategoriesTree?.filter(x => x.isChecked).map((cat, idx) =>
                                        cat.subcats.some(y => y.isChecked)
                                            ? cat.subcats && cat.subcats.filter(y => y.isChecked).map(sc =>
                                                <Chip key={idx} size='small' variant='outlined' sx={{ color: colors.indigo[900], margin: '0 5px', px: 1, py: 2 }} label={cat.cat_name + ' > ' + sc.sub_cat_name} />)
                                            : <Chip key={idx} size='small' variant='outlined' sx={{ color: colors.indigo[900], margin: '0 5px', px: 1, py: 2 }} label={cat.cat_name} />)}
                                </Box>

                                {/* Manage Categories */}
                                <Box display="flex" flexDirection="row" justifyContent="space-between" alignContent="center" alignItems="center" my={1} boxShadow={2} p={2}>
                                    <Box>
                                        <Button variant='outlined' size='large' onClick={() => setOpenCategoryModal(p => !p)} startIcon={<ManageSearchSharp fontSize='large' color='secondary' />}>Manage Categories</Button>
                                    </Box>
                                    {/* <Box>
                                    <TextField
                                        select
                                        id="weight"
                                        label="News Weight"
                                        size="small"
                                        value={selectedWeight}
                                        onChange={(e) => setSelectedWeight(e.target.value)}
                                        style={{ margin: "5px 0px", textAlign: 'left', width: '150px' }}
                                        inputProps={{ style: { height: "200px" } }}
                                    >
                                        {weightList.length > 0 &&
                                            weightList.map((weight, idx) =>
                                                <MenuItem
                                                    key={idx}
                                                    id={idx}
                                                    value={weight}
                                                >
                                                    {weight}
                                                </MenuItem>
                                            )}
                                    </TextField>
                                </Box> */}
                                    <Box>
                                        <TextField
                                            type='number'
                                            id="priority"
                                            label="News Priority"
                                            size="small"
                                            value={selectedPriority}
                                            onChange={(e) => setSelectedPriority(e.target.value)}
                                            style={{ margin: "5px 0px", textAlign: 'left', width: '150px' }}
                                        />
                                    </Box>
                                    <Box>
                                        <TextField
                                            type='number'
                                            id="weight"
                                            label="News Weight"
                                            size="small"
                                            value={selectedWeight}
                                            onChange={(e) => setSelectedWeight(e.target.value)}
                                            style={{ margin: "5px 0px", textAlign: 'left', width: '150px' }}
                                        />
                                    </Box>
                                    <Box>
                                        <FormControlLabel
                                            label="Is Featured Article"
                                            control={
                                                <Checkbox
                                                    size='large'
                                                    checked={isFeatured}
                                                    onChange={() => setIsFeatured(!isFeatured)}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />}
                                        />
                                    </Box>
                                </Box>

                                {/* Article Title */}
                                <Box my={1} boxShadow={2} p={2}>
                                    <Box width="100%" flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                        <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Headline:</Typography>
                                    </Box>
                                    <TextField
                                        id="standard-basic"
                                        // label="News Title"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        value={articleTitle}
                                        onChange={(e) => setArticleTitle(e.target.value)}
                                    />
                                </Box>
                                {/* Article Summary */}
                                <Box my={1} boxShadow={2} p={2}>
                                    <Box width="100%" flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                        <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Strapline:</Typography>
                                    </Box>
                                    <TextField
                                        id="standard-basic"
                                        // label="News Summary"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        multiline
                                        minRows={1}
                                        maxRows={3}
                                        value={articleSummary}
                                        onChange={(e) => setArticleSummary(e.target.value)}
                                    />
                                </Box>

                                {/* Article Photo */}
                                <Box my={1} boxShadow={2} p={2}>
                                    <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Choose Article Images:</Typography>
                                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                                        <Box width='49%'>
                                            <Box position="relative" display='flex' justifyContent='flex-start' alignItems='center' border={1} borderColor={colors.blueGrey[100]} borderRadius={1} boxShadow={1}>
                                                {/* <IconButton sx={{ position: "absolute", top: 0, right: 0, visibility: articlePictureFile ? "visible" : "hidden" }} title="Delete Photo"
                                                onClick={() => { setArticlePhoto(null); setArticlePictureFile(null) }} size="small">
                                                <ClearIcon color="error" fontSize='medium' />
                                            </IconButton> */}
                                                {/* <img width="99%" src={articlePictureFile} /> */}

                                                {imageList?.length > 0 &&
                                                    <>
                                                        <Box display='flex' flexDirection='column' width='100%' overflow="none" >
                                                            <Box>
                                                                <SimpleImageSlider
                                                                    width={'100%'}
                                                                    height={200}
                                                                    // images={imageList.map(img => img.uri || JSON.parse(img)?.renditions?.preview?.href)}
                                                                    images={imageList}
                                                                    showBullets={true}
                                                                // showNavs={true}
                                                                />
                                                            </Box>
                                                            <Box>
                                                                {imageList?.map((img, idx) =>
                                                                    img && <Chip key={idx} label={img.name || img.uri || img.url} size='small' onDelete={(e) => { handleImageDelete(img); setIsModified(true) }} />)}
                                                            </Box>
                                                        </Box>
                                                    </>
                                                    // || JSON.parse(img).renditions.preview.originalfilename
                                                }
                                            </Box>
                                            <Box display='flex' justifyContent='flex-end' alignItems='center'>
                                                <Button variant="text" component="label" size='small' title='Upload Image'
                                                    endIcon={<PhotoCamera color='secondary' fontSize='small' name='Upload Image' />}>
                                                    Upload Image
                                                    <input hidden multiple accept="image/*" type="file" name="article_photos"
                                                        onChange={(event) => { uploadProfilePicture(event); setIsModified(true) }}
                                                    />
                                                </Button>
                                            </Box>
                                        </Box>
                                        <Box width='49%'>
                                            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} >
                                                <TextField
                                                    select
                                                    required
                                                    id="store-image"
                                                    label="Store Image"
                                                    variant="standard"
                                                    size="small"
                                                    value={imageType}
                                                    onChange={(e) => { setImageType(e.target.value); setIsModified(() => imageType !== e.target.value); }}
                                                    style={{ textAlign: 'left', width: '150px' }}
                                                    inputProps={{ style: { height: "200px" } }}
                                                >
                                                    <MenuItem value={'company'}>Company Image</MenuItem>
                                                    <MenuItem value={'article'}>Article Image</MenuItem>
                                                </TextField>

                                                <Box mt={2} mx={1}>{!imageType && <AssistantPhoto color='error' />}</Box>
                                            </Box>
                                            <Box my={2}>
                                                <TextField
                                                    required
                                                    id="standard-basic"
                                                    label="Image Alt Tag Text"
                                                    variant="standard"
                                                    style={{ width: "100%" }}
                                                    fullWidth
                                                    value={imageAltTag}
                                                    // disabled={!articlePictureFile}
                                                    onChange={(e) => { setImageAltTag(e.target.value); setIsModified(() => imageAltTag !== e.target.value) }}
                                                />
                                            </Box>
                                            <Box>
                                                <TextField
                                                    required
                                                    id="standard-basic"
                                                    label="Image Caption Text"
                                                    variant="standard"
                                                    style={{ width: "100%" }}
                                                    value={imageCaption}
                                                    // disabled={!articlePictureFile}
                                                    onChange={(e) => { setImageCaption(e.target.value); setIsModified(() => imageCaption !== e.target.value) }}
                                                />
                                            </Box>
                                            <Box my={2}>
                                                <TextField
                                                    id="standard-basic"
                                                    label="Image Credit (optional)"
                                                    variant="standard"
                                                    style={{ width: "100%" }}
                                                    value={imageCredit}
                                                    // disabled={!articlePictureFile}
                                                    onChange={(e) => { setImageCredit(e.target.value); setIsModified(() => imageCaption !== e.target.value) }}
                                                />
                                            </Box>

                                            <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                                <Button size='small' disabled={!isModified} variant='contained' onClick={handleSaveImage}>Save</Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Article Bullets Section */}
                                <Box my={1} boxShadow={2} p={2} >
                                    <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Bullets:</Typography>
                                    <BulletsSection data={articleContent?.article_bullets} />
                                </Box>

                                {/* Article Description */}
                                <Box my={1} boxShadow={2} p={2} minHeight={500} >
                                    <Box width="100%" flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                        <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Content:</Typography>
                                    </Box>
                                    {/* <Editor
                                        editorState={articleDescriptionState}
                                        wrapperClassName="wrapper-class"
                                        editorClassName="editor-class"
                                        toolbarClassName="toolbar-class"
                                        onEditorStateChange={handleEditorArticleDescription}
                                        toolbar={{
                                            link: { inDropdown: true },
                                            history: { inDropdown: true },
                                            image: { previewImage: false, alt: { present: true, mandatory: true }, },
                                            table: true, // Enable table button in toolbar
                                        }}
                                        placeholder={('Article Content...')}
                                        editorStyle={{ height: "350px" }}
                                    /> */}
                                    <ReactQuill
                                        ref={quillRef}
                                        value={articleDescription}
                                        onChange={handleChange}
                                        modules={modules}
                                        formats={formats}
                                        theme="snow"
                                        placeholder="Start writing here..."
                                        style={{ height: "400px" }}
                                    />
                                </Box>

                                {/* Article Tabular Data Section */}
                                <Box my={1} boxShadow={2} p={2} >
                                    <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Tabular Data:</Typography>
                                    <FinancialTableComp data={articleContent?.article_table} />
                                </Box>

                                {/* Related Articles Section */}
                                <Box my={1} boxShadow={2} p={2} >
                                    <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Related Articles Section:</Typography>
                                    <RelatedArticleSection data={articleContent?.related_news} />
                                </Box>

                                {/* Articles Disclaimer Section */}
                                <Box my={1} boxShadow={2} p={2} >
                                    <Typography variant='h6' color={colors.deepOrange[800]} sx={{ textAlign: 'left' }}>Article Disclaimer Section:</Typography>
                                    <div dangerouslySetInnerHTML={{ __html: articleContent?.article_disclaimer }} />
                                </Box>

                                {/* Location--People-Industry */}
                                <Box display="flex" flexDirection="row" justifyContent="space-evenly" my={1} boxShadow={2} p={2} >
                                    <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                        <Box>
                                            <TextField
                                                type="text"
                                                variant='standard'
                                                className="search"
                                                placeholder="Enter Location Name..."
                                                label='Location'
                                                fullWidth
                                                // style={{ width: "250px" }}
                                                InputLabelProps={{ shrink: true }}
                                                // onChange={(e) => {
                                                //     if (e.target.value) {
                                                //         setParentCompany(e.target.value)
                                                //         optimizedFn(e.target.value)
                                                //     } else
                                                //         setCompanySuggestions([])
                                                // }}
                                                // onFocus={() => SetSuggDropDownState(true)}
                                                // onBlur={() => setTimeout(() => {
                                                //     SetSuggDropDownState(false)
                                                // }, 100)}
                                                // defaultValue={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                                value={location}
                                                InputProps={{
                                                    endAdornment: (
                                                        <>
                                                            {locationSuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                            <IconButton onClick={() => { setLocation(""); setLocationSuggestions([]) }} size="small">
                                                                <ClearSharp />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleLocationList({ code: "", name: location })} size="small">
                                                                <AddBoxSharp />
                                                            </IconButton>
                                                        </>
                                                    )
                                                }}
                                            />
                                            {locationSuggestion.length && locationSuggDropDownState
                                                ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: '100%', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                                    {locationSuggestion.map((option, idx) =>
                                                        <MenuItem
                                                            key={option.code || idx}
                                                            sx={{ fontSize: 13 }}
                                                            value={option.name}
                                                            onClick={() => {
                                                                handleLocationList(option);
                                                                setTimeout(() => {
                                                                    setLocationSuggDropDownState(false);
                                                                }, 100);
                                                            }}
                                                        >
                                                            {option.name}
                                                        </MenuItem>
                                                    )}
                                                </Box>
                                                : null}
                                        </Box>
                                        <Box>
                                            {locationList.length > 0 ? locationList.map((loc, idx) =>
                                                loc && <Chip key={idx} label={loc.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteLocation(loc)} />
                                            ) : null}
                                        </Box>
                                    </Box>

                                    {/* ASSOCIATED PEOPLE */}
                                    <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                        <Box>
                                            <TextField
                                                type="text"
                                                variant='standard'
                                                className="search"
                                                placeholder="Enter People Name..."
                                                label='People Name'
                                                fullWidth
                                                // style={{ width: "250px" }}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={(e) => {
                                                    if (e.target.value) {
                                                        setPeopleNames(e.target.value)
                                                        optimizedPeopleFn(e.target.value)
                                                    } else
                                                        setPeopleNames("")
                                                    setPeopleSuggestions([])
                                                }}
                                                onFocus={() => setPeopleSuggDropDownState(true)}
                                                // onBlur={() => setTimeout(() => {
                                                //     setPeopleSuggDropDownState(false)
                                                // }, 100)}
                                                // defaultValue={peopleNames}
                                                value={peopleNames}
                                                InputProps={{
                                                    endAdornment: (
                                                        <>
                                                            {peopleSuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                            <IconButton onClick={() => { setPeopleNames(""); setPeopleSuggestions([]) }} size="small">
                                                                <ClearSharp />
                                                            </IconButton>
                                                            {/* <IconButton onClick={() => handlePeopleNamesList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                        </>
                                                    )
                                                }}
                                            />
                                            {peopleSuggestion.length && peopleSuggDropDownState
                                                ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                                    {peopleSuggestion.map((option, idx) =>
                                                        <MenuItem
                                                            key={option.insider_cik || idx}
                                                            sx={{ fontSize: 13 }}
                                                            value={option.name}
                                                            onClick={() => {
                                                                setTimeout(() => {
                                                                    setPeopleSuggDropDownState(false);
                                                                }, 250);
                                                                handlePeopleNamesList(option);
                                                            }}
                                                        >
                                                            {option.name}&nbsp;{option.relatedto && <span style={{ color: colors.blue[400], fontWeight: 500 }}>({option.relatedto})</span>}
                                                        </MenuItem>
                                                    )}
                                                </Box>
                                                : null}
                                        </Box>
                                        <Box>
                                            {peopleNamesList?.length
                                                ? peopleNamesList.map((ppl, idx) =>
                                                    ppl && <Chip key={ppl.id || idx} label={ppl.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeletePeople(ppl)} />
                                                ) : null}
                                        </Box>
                                    </Box>

                                    {/* ASSOCIATED COMPANIES SECTION */}
                                    <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                        <Box>
                                            <TextField
                                                type="text"
                                                variant='standard'
                                                className="search"
                                                placeholder="Enter Ticker Company Name..."
                                                label='Associated Companies'
                                                fullWidth
                                                // style={{ width: "250px" }}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={(e) => {
                                                    if (e.target.value) {
                                                        setCompany(e.target.value)
                                                        optimizedCompanyFn(e.target.value)
                                                    } else
                                                        setCompany("")
                                                    setCompanySuggestions([])
                                                }}
                                                onFocus={() => setCompanySuggDropDownState(true)}
                                                // onBlur={() => setTimeout(() => {
                                                //     setCompanySuggDropDownState(false)
                                                // }, 100)}
                                                // defaultValue={company}
                                                value={company}
                                                InputProps={{
                                                    endAdornment: (
                                                        <>
                                                            {companySuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                            <IconButton onClick={() => { setCompany(""); setCompanySuggestions([]) }} size="small">
                                                                <ClearSharp />
                                                            </IconButton>
                                                            {/* <IconButton onClick={() => handlecompanyList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                        </>
                                                    )
                                                }}
                                            />
                                            {companySuggestion.length && companySuggDropDownState
                                                ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                                    {companySuggestion.map((option, idx) =>
                                                        <MenuItem
                                                            key={option.cik || idx}
                                                            sx={{ fontSize: 13 }}
                                                            value={option.name}
                                                            onClick={() => {
                                                                setTimeout(() => {
                                                                    setCompanySuggDropDownState(false);
                                                                }, 250);
                                                                handleCompanyList(option);
                                                            }}
                                                        >
                                                            {option.name || option}&nbsp;
                                                            {option.ticker && <span style={{ color: colors.blue[400], fontWeight: 500 }}>[{option.ticker}]</span>}
                                                        </MenuItem>
                                                    )}
                                                </Box>
                                                : null}
                                        </Box>
                                        <Box>
                                            {companyList?.length > 0 ? companyList.map((comp, idx) =>
                                                comp && <Chip key={comp?.company_name || idx} label={comp?.company_name || comp} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteCompany(comp)} />
                                            ) : null}
                                        </Box>
                                    </Box>

                                    {/* ASSOCIATED SIC OR INDUSTRIES */}
                                    <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                        <Box>
                                            <TextField
                                                type="text"
                                                variant='standard'
                                                className="search"
                                                placeholder="Enter Industry Name..."
                                                label='SIC | Industry'
                                                fullWidth
                                                // style={{ width: "250px" }}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={(e) => {
                                                    if (e.target.value) {
                                                        setIndustry(e.target.value)
                                                        optimizedIndustryeFn(e.target.value)
                                                    } else
                                                        setIndustry("")
                                                    setIndustrySuggestions([])
                                                }}
                                                onFocus={() => setIndustrySuggDropDownState(true)}
                                                // onBlur={() => setTimeout(() => {
                                                //     setIndustrySuggDropDownState(false)
                                                // }, 100)}
                                                // defaultValue={industry}
                                                value={industry}
                                                InputProps={{
                                                    endAdornment: (
                                                        <>
                                                            {industrySuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                            <IconButton onClick={() => { setIndustry(""); setIndustrySuggestions([]) }} size="small">
                                                                <ClearSharp />
                                                            </IconButton>
                                                            {/* <IconButton onClick={() => handleIndustryList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                        </>
                                                    )
                                                }}
                                            />
                                            {industrySuggestion.length && industrySuggDropDownState
                                                ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                                    {industrySuggestion.map((option, idx) =>
                                                        <MenuItem
                                                            sx={{ fontSize: 13 }}
                                                            key={option.code || idx}
                                                            value={option.sic_name}
                                                            onClick={() => {
                                                                handleIndustryList(option);
                                                                setTimeout(() => {
                                                                    setIndustrySuggDropDownState(false);
                                                                }, 100);
                                                            }}
                                                        >
                                                            {option.sic_name}&nbsp;<span style={{ color: colors.blue[400], fontWeight: 500 }}>[{option.sic_grp_name}]</span>
                                                        </MenuItem>
                                                    )}
                                                </Box>
                                                : null}
                                        </Box>
                                        <Box>
                                            {industryList?.length ? industryList.map((ind, idx) =>
                                                <Chip key={ind.code || idx} label={ind.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteIndustry(ind)} />
                                            ) : null}
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Macro-Indicator Drop Down */}
                                <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignContent="center" alignItems="center" my={1} boxShadow={2} p={2} >
                                    <Box width="35%">
                                        <FormControl fullWidth>
                                            <InputLabel id="article-sub-category-multiple-checkbox-label">Macro Indicator Category</InputLabel>
                                            <Select
                                                fullWidth
                                                variant='outlined'
                                                label="Select Macro Indicator Category"
                                                InputLabelProps={{ shrink: true }}
                                                value={selectedMacroIndicator}
                                                MenuProps={menuprops}
                                                input={<OutlinedInput label="Article Sub Category" />}
                                                onChange={(e) => setSelectedMacroIndicator(e.target.value)}
                                            >
                                                {assignedMasterMacroIndicatorTree.length > 0 &&
                                                    assignedMasterMacroIndicatorTree.map((category, idx) =>
                                                        <MenuItem key={idx} id={category.category_id} value={category} sx={{ fontSize: 14, padding: 1 }}>
                                                            {category.category_name}
                                                        </MenuItem>
                                                    )}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                    {/* Macro-Indicator Sub Drop Down */}
                                    <Box width="45%">
                                        <FormControl fullWidth>
                                            <InputLabel id="article-sub-category-multiple-checkbox-label">Macro Indicators</InputLabel>
                                            <Select
                                                multiple
                                                fullWidth
                                                disabled={!selectedMacroIndicator}
                                                label="Select Macro Indicator Category"
                                                value={selectedMacroSubIndicatorList}
                                                renderValue={selectedIndicators => selectedIndicators.map(ind => ind.indicator_name).join(", ")}
                                                onChange={(e) => setSelectedMacroSubIndicatorList(e.target.value)}
                                                input={<OutlinedInput label="Article Sub Category " />}
                                                MenuProps={menuprops}>
                                                {selectedMacroIndicator && assignedMasterMacroIndicatorTree
                                                    .filter(f => f.category_id === selectedMacroIndicator.category_id)[0].indicators
                                                    .map((ind, idx) =>
                                                        <MenuItem key={ind.indicator_id || idx} value={ind} /* disabled={ind.sub_cat_hide} */
                                                            onChange={(e) => handleMacroIndicatorChange(e, ind, selectedMacroIndicator)}
                                                            sx={{ fontSize: 14, padding: 0 }}>
                                                            <Checkbox checked={ind.isChecked} value={ind.indicator_name} />{ind.indicator_name}
                                                        </MenuItem>
                                                    )}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box width="5%">
                                        <Button size='small' variant='outlined' onClick={handleAssignMacroIndicator} >Assign</Button>
                                    </Box>
                                </Box>
                                <Box width="100%" display='flex' flexDirection='row' justifyContent='flex-start' alignItems='flex-start' flexWrap='wrap' m={1}>
                                    {selectedMacroIndicatorList.length
                                        ? selectedMacroIndicatorList.map((cat, idx) => {
                                            if (cat.isChecked) {
                                                console.log('CHECKED INDICATOR === ', cat)
                                                let ind = cat.indicators.filter(ind => ind.isChecked);
                                                return <Chip key={cat.category_name || idx} label={`${cat.category_name} > ${ind.map(o => o.indicator_name)}`} sx={{ m: 1 }} size='small' />
                                            }
                                        })
                                        : null}
                                </Box>

                                {/* Author--version-Date */}
                                <Box display="flex" flexDirection="row" justifyContent="space-evenly" my={1} boxShadow={2} p={2} >
                                    <Box mx={1}>
                                        {/* Earlier implementation
                                        <TextField
                                            id="standard-basic"
                                            label="Author"
                                            variant="standard"
                                            // style={{ width: "250px" }}
                                            value={author}
                                            onChange={(e) => setAuthor(e.target.value)}
                                        />
                                        */}
                                        {isPendingAutodraft
                                            ? <FormControl variant="standard" sx={{ minWidth: 180 }}>
                                                <InputLabel id="article-author-select-label">Author</InputLabel>
                                                <Select
                                                    labelId="article-author-select-label"
                                                    id="article-author-select"
                                                    value={author}
                                                    onChange={(e) => setAuthor(e.target.value)}
                                                >
                                                    <MenuItem value={articleContent.author_name}>{articleContent.author_name}</MenuItem>
                                                    {/* Earlier implementation
                                                    <MenuItem value={String(currentUser.userid)}>{currentUser.first_name}</MenuItem>
                                                    */}
                                                    <MenuItem value={String(currentUser.userid)}>{loggedInEditorName || currentUser.first_name}</MenuItem>
                                                </Select>
                                            </FormControl>
                                            : <TextField
                                                id="standard-basic"
                                                label="Author"
                                                variant="standard"
                                                value={author}
                                                disabled
                                            />}
                                    </Box>
                                    <Box mx={1}>
                                        <Typography variant='caption' sx={{ fontWeight: 700, color: colors.blueGrey[700], textAlign: 'left', lineHeight: 2.3 }}>First Published Date:&nbsp;
                                            <Typography variant="body2" color={colors.blueGrey[800]} sx={{ textAlign: 'left' }}>{new Date(datePublished).toLocaleString()}</Typography>
                                        </Typography>
                                    </Box>
                                    <Box mx={1}>
                                        <Typography variant='caption' sx={{ fontWeight: 700, color: colors.blueGrey[700], textAlign: 'left', lineHeight: 2.3 }}>Last Updated:&nbsp;
                                            <Typography variant="body2" color={colors.blueGrey[800]} sx={{ textAlign: 'left' }}>{new Date(lastUpdated).toLocaleString()}</Typography>
                                        </Typography>
                                    </Box>
                                    <Box mx={1}>
                                        <Typography variant='caption' sx={{ fontWeight: 700, color: colors.deepOrange[700], fontSize: 16, textAlign: 'left', lineHeight: 2.3 }}>Is Article Indexable:&nbsp;
                                            <Checkbox
                                                size='medium'
                                                checked={isArticleIndexable}
                                                onChange={() => setIsArticleIndexable(!isArticleIndexable)}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Typography>
                                    </Box>
                                </Box>


                                {/* *************************************** */}
                                {/* SEARCH & ATTACH RELATED ARTICLE SECTION  */}
                                {/* *************************************** */}

                                <Box display='flex' flexDirection='column' my={1} boxShadow={2} p={2}>
                                    <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Attach Links to Original Article:</Typography>
                                    <Typography variant='h5' fontSize={14} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left', marginLeft: 1 }}>Attached links:</Typography>
                                    <Box display='flex' flexDirection={'column'} justifyContent='space-between' alignContent='flex-start' alignItems='flex-start' flexWrap='wrap' mt={1}>
                                        {editorsSelectedArticles.length ? editorsSelectedArticles.map((art) => (
                                            <Chip label={art.title} sx={{ mb: 1 }} size='small' color='primary' onDelete={() => handleRemoveRelatedArticle(art.article_id)} />
                                        )) : null}
                                    </Box>
                                    <Typography variant='h3' fontSize={14} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left', marginLeft: 1 }}>Search Related Article:</Typography>
                                    <Box width={'100%'} display={'flex'} flexDirection={'row'} justifyContent='space-between' alignItems={'center'} flexWrap='wrap'>
                                        <Box mt={1}>
                                            <TextField
                                                id="search_author"
                                                label="Search By Author"
                                                variant="outlined"
                                                size="small"
                                                value={searchByAuthor}
                                                onChange={(e) => setSearchByAuthor(e.target.value)}
                                                style={{ textAlign: 'left', width: '280px' }}
                                            />

                                        </Box>
                                        <Box mt={1}>
                                            <TextField
                                                select
                                                id="search_author"
                                                variant="outlined"
                                                label="Search By Category"
                                                size="small"
                                                value={searchByCategoryId}
                                                onChange={(e) => setSearchByCategoryId(e.target.value)}
                                                style={{ textAlign: 'left', width: '280px' }}
                                                inputProps={{ style: { height: "200px" } }}
                                            >
                                                {masterCategoriesSubCategoriesTree.map((cat, i) => (
                                                    <MenuItem key={i} value={cat.cat_id}>{cat.cat_name}</MenuItem>
                                                ))}

                                            </TextField>
                                        </Box>
                                        <Box mt={1}>
                                            <TextField
                                                select
                                                disabled={searchByCategoryId ? false : true}
                                                id="search_author"
                                                variant="outlined"
                                                label="Search By Sub Category"
                                                size="small"
                                                value={searchBySubCategoryId}
                                                onChange={(e) => setSearchBySubCategoryId(e.target.value)}
                                                style={{ textAlign: 'left', width: '280px' }}
                                                inputProps={{ style: { height: "200px" } }}
                                            >
                                                {masterCategoriesSubCategoriesTree.find(cat => cat.cat_id === searchByCategoryId)?.subcats?.map((subcat, i) => (
                                                    <MenuItem key={i} value={subcat.sub_cat_id}>{subcat.sub_cat_name}</MenuItem>
                                                ))}

                                            </TextField>
                                        </Box>
                                        <Box mt={1}>
                                            <TextField
                                                name='company'
                                                title='company Name'
                                                variant='outlined'
                                                label="Search By Company"
                                                size='small'
                                                placeholder='Enter company Ticker/Name'
                                                style={{ width: "280px" }}
                                                value={searchCompany}
                                                onChange={(event) => setSearchCompany(event.target.value)}
                                            />
                                        </Box>
                                        <Box mt={1}>
                                            <TextField
                                                name='keywords'
                                                title='keywords'
                                                variant='outlined'
                                                label="Search By Keywords"
                                                size='small'
                                                placeholder='Enter Keywords'
                                                style={{ width: "280px" }}
                                                value={searchKeywords}
                                                onChange={(event) => setSearchKeywords(event.target.value)}
                                            />
                                        </Box>
                                        <Box mt={1}>
                                            <ReactDatePicker id="ReactDatePicker"
                                                monthsShown={2}
                                                className='ReactDatePicker'
                                                dateFormat="MMM dd, yyyy"
                                                selectsRange={true}
                                                startDate={dateRange[0]}
                                                endDate={dateRange[1]}
                                                maxDate={new Date()}
                                                onChange={date_range => handleDateRange(date_range)}
                                            />
                                        </Box>
                                        <Box mt={1}>
                                            <Button variant='outlined' size='small' onClick={handleSearchArticle}>Search</Button>
                                        </Box>
                                    </Box>
                                    {searchResultArticles?.length && searchResultArticles.length > 0 ?
                                        <Box display={'flex'} flexDirection={'column'}>
                                            <div style={{ padding: '10px 20px' }}>
                                                <h3>Select Articles</h3>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    {searchResultArticles?.map((article) => (
                                                        <label
                                                            key={article.article_id}
                                                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: 'max-content' }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={editorsSelectedArticlesId?.length === 0 ? "" :editorsSelectedArticlesId?.includes(article.article_id)}
                                                                onChange={() => handleArticleSelect(article.article_id)}
                                                                style={{ marginRight: '10px', height: '20px', width: '20px' }}
                                                            />
                                                            <a href={`https://candorium.com/news/${article?.article_id}/${article.title_slug}`} target='_blank'>{article.title}</a>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                            <Box display='flex' justifyContent='center' p={2}>
                                                <Button variant='contained' color='info' size='small' sx={{ margin: '0 10px' }} onClick={handleSelectedArticles}>Attach Links to Article</Button>
                                            </Box>
                                        </Box>
                                        : null}
                                </Box>

                                <Box display='flex' justifyContent='space-between' mx={1} mt={2} mb={3} >
                                    <Button variant='contained' color='inherit' onClick={() => history.push('/home')}>Cancel</Button>
                                    <Button variant='contained' color='primary' onClick={() => saveArticle(false)}>Save</Button>
                                </Box>
                            </Box>
                    }
                </>
                : <LinearProgress />}

            <Dialog
                open={openCategoryModal}
                onClose={() => setOpenCategoryModal(false)}
                maxWidth='lg'
            >
                <Box sx={{
                    columnCount: { xs: 1, sm: 2, md: 4 }, // Adjust columns based on screen size
                    columnGap: '20px', // Smaller gap between columns
                    padding: 1,
                    margin: 0
                }} boxShadow={5}>
                    {assignedMasterCategoriesSubCategoriesTree.map(category => (
                        <Box sx={{
                            backgroundColor: colors.blueGrey[50],
                            borderRadius: '8px',
                            marginBottom: '15px', // Gap between cards in the same column
                            breakInside: 'avoid', // Prevents breaking within columns
                            padding: 2,
                            display: 'inline-block', // Required for column layout
                            width: '90%', // Ensures full width within the column
                        }}>
                            <ManageCategoriesComp
                                category={category}
                                assignedMasterCategoriesSubCategoriesTree={assignedMasterCategoriesSubCategoriesTree}
                                setAssignedMasterCategoriesSubCategoriesTree={setAssignedMasterCategoriesSubCategoriesTree} />
                        </Box>
                    ))}
                </Box>
            </Dialog>
        </>
    )
}

export default Article
